// extracted by mini-css-extract-plugin
module.exports = {"root":"RequestDetails_root__1tqJp","title":"RequestDetails_title__117qJ"};